import LiveFeedback from '../Component/LiveFeedback';
import ModalCloseButton from '../../../../Component/UI/ModalCloseButton';
import styled from "styled-components";
import { modalProps } from "../../../../Component/Interface/Modal";
import {
  CenterView,

  RowView,
} from "../../../../Component/style/common_style";
import { amountFormat } from "../../../../Component/tool/Tools";
import { useEffect, useState, useRef, useId } from "react";
import api from "../../../../Component/axios_Interceptor/api";
import url, { SERVER_ADDRESS } from "../../../../Component/server";
import { StoreInfo } from "../../../../Component/Interface/Store";
import { useParams } from "react-router-dom";
import { live_info_type } from "../../../User/Live/Live";

interface SendPaymentModalProps extends modalProps {
  sendType: string;
  onDispatched?: () => void;
  readOnly?: boolean;
  store_info?: StoreInfo;
  liveSeq?: number;
}

const SendPaymentModal = ({
  visible,
  handleModal,
  sendType,
  onDispatched,
  readOnly = false,
  liveSeq,
}: SendPaymentModalProps) => {
  const closeModal = () => {
    setConfirming(false);
    handleModal();
  };

  const stopPropagation = (e: React.MouseEvent) => {
    e.stopPropagation();
  };
  const { seq: routeSeq } = useParams();
  const seq = liveSeq === undefined ? routeSeq : String(liveSeq);
  const [useCoin, setUseCoin] = useState(0);
  const [myCoin, setMyCoin] = useState<number | null>(null);
  const [liveInfo, setLiveInfo] = useState<live_info_type>();
  const [alimtalk_count, set_Alimtalk_Count] = useState(0);
  const [order_count, set_Order_Count] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [loadError, setLoadError] = useState("");
  const [sending, setSending] = useState(false);
  const sendingRef = useRef(false);
  const contextRef = useRef(0);
  const [result, setResult] = useState<any>(null);
  const [sendError, setSendError] = useState("");
  const [confirming, setConfirming] = useState(false);
  const confirmationRef = useRef<HTMLDivElement>(null);
  const confirmationTitleId = useId();
  const confirmationBodyId = useId();

  useEffect(() => {
    if (!visible || !confirming) return;
    const previousFocus = document.activeElement as HTMLElement | null;
    const panel = confirmationRef.current;
    panel?.querySelector<HTMLButtonElement>('button')?.focus();
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        event.preventDefault();
        setConfirming(false);
      }
      if (event.key !== "Tab" || !panel) return;
      const controls = Array.from(panel.querySelectorAll<HTMLButtonElement>('button:not([disabled])'));
      const first = controls[0], last = controls[controls.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault(); last?.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault(); first?.focus();
      }
    };
    panel?.addEventListener('keydown', handleKeyDown);
    return () => {
      panel?.removeEventListener('keydown', handleKeyDown);
      previousFocus?.focus();
    };
  }, [visible, confirming]);

  const submitDispatch = async () => {
    if (readOnly || sendingRef.current || result) return;
    const context = contextRef.current;
    sendingRef.current = true; setSending(true); setConfirming(false); setSendError("");
    try {
      const res = await api.post(sendType === "알림톡" ? url.Communication_url.send_alimtalk : url.Communication_url.send_statement, {
        live_seq: seq,
        coin: useCoin,
        ...(sendType === "알림톡" ? { live_title: liveInfo?.live_title } : { order_count }),
        retry_failed: false,
      });
      if (context !== contextRef.current) return;
      if (!Number.isSafeInteger(res.data?.dispatch_id)) throw new Error("발송 접수 결과를 확인하지 못했습니다.");
      setResult(res.data);
      onDispatched?.();
      const balance = await api.get(url.Communication_url.stock_coin);
      if (context !== contextRef.current) return;
      if (balance.data?.coin == null || !Number.isFinite(Number(balance.data.coin))) throw new Error("잔액을 다시 조회하지 못했습니다.");
      setMyCoin(Number(balance.data.coin));
    } catch (error: any) { if (context === contextRef.current) setSendError(error?.response?.data?.message || error.message || "발송 처리 중 오류가 발생했습니다."); }
    finally { if (context === contextRef.current) { sendingRef.current = false; setSending(false); } }
  };

  useEffect(() => {
    if (!visible || !result?.dispatch_id) return;
    let active = true, timer: ReturnType<typeof setTimeout>;
    const poll = async () => {
      try {
        const res = await api.get(`${SERVER_ADDRESS}notifications/${result.dispatch_id}`);
        if (!active) return;
        setResult(res.data); setSendError("");
        const balance = await api.get(url.Communication_url.stock_coin);
        if (active && balance.data?.coin != null) setMyCoin(Number(balance.data.coin));
        if (active && (res.data.pending_cnt > 0 || res.data.send_cnt > res.data.delivered_cnt)) timer = setTimeout(poll, 3000);
      } catch { if (active) { setSendError("발송 결과를 조회하지 못했습니다. 창을 다시 열어 확인해주세요."); } }
    };
    poll();
    return () => { active = false; clearTimeout(timer); };
  }, [visible, result?.dispatch_id, result?.pending_cnt > 0, result?.send_cnt > result?.delivered_cnt]);

  useEffect(() => {
    let active = true;
    contextRef.current += 1;
    sendingRef.current = false;
    setSending(false);
    setMyCoin(null);
    setLoadError("");
    setResult(null); setSendError("");
    setConfirming(false);
    setIsLoading(true);
    if (visible) Promise.all([
      api.get(url.Communication_url.get_live_info, { params: { seq } }),
      api.get(url.Communication_url.stock_coin),
      api.get(`${SERVER_ADDRESS}notifications/preview/${seq}`, { params: { kind: sendType === '알림톡' ? 'start' : 'statement' } }),
    ]).then(([live, balance, recipients]) => {
      const rawCount = recipients.data.recipient_count;
      const count = Number(rawCount);
      const estimate = recipients.data.estimated_coins;
      if (balance.data.coin == null || !Number.isFinite(Number(balance.data.coin))
        || rawCount == null || !Number.isInteger(count) || count < 0
        || !Number.isSafeInteger(estimate) || estimate < 0) throw new Error("Invalid payment information");
      if (!active) return;
      setLiveInfo(live.data);
      setMyCoin(Number(balance.data.coin));
      set_Alimtalk_Count(sendType === "알림톡" ? count : 0);
      set_Order_Count(sendType === "알림톡" ? 0 : count);
      setUseCoin(estimate);
      setResult(recipients.data.dispatch);
    }).catch(() => {
      if (active) setLoadError("결제 정보를 불러오지 못했습니다. 창을 다시 열어주세요.");
    }).finally(() => { if (active) setIsLoading(false); });
    return () => { active = false; contextRef.current += 1; };
  }, [visible, sendType, seq]);

  return (
    <Container data-admin-modal-overlay="" style={visible ? {} : { display: "none" }} onClick={closeModal}>
      <ModalBox data-admin-modal="" role="dialog" aria-modal="true" aria-label={sendType === "알림톡" ? "시작톡 보내기" : "정산서 보내기"} onClick={stopPropagation} aria-hidden={confirming || undefined}>
        <Title data-admin-modal-header="">
          <RowView data-admin-modal-heading-row="">
            <div>{sendType === "알림톡" ? "시작톡" : sendType} 보내기</div>
            <ModalCloseButton tone="admin" aria-label="발송 창 닫기" className="btn" onClick={closeModal} />
          </RowView>
        </Title>
        <div data-admin-modal-body="">{isLoading ? (
          <Loading>
            <div className="loading" />
          </Loading>
        ) : loadError ? <RedText as={LiveFeedback} role="alert">{loadError}</RedText> : (
          <ContentDiv>
            <RowView style={{ width: "100%" }}>
              <RowView style={{ gap: 10 }}>
                <div>대상자</div>
                <div className="black">
                  {amountFormat(
                    sendType === "알림톡" ? alimtalk_count : order_count
                  )}
                  명
                </div>
              </RowView>
              <div className="black">
                {useCoin}
                C
              </div>
            </RowView>
            <Bar />
            <RowView style={{ width: "100%" }}>
              <div className="black">{result ? '현재 사용 코인' : '예상 사용 코인'}</div>
              <div className="usecoin">{amountFormat(result ? result.charged_coins : useCoin)}C</div>
            </RowView>
            <div className="mycoin">보유 코인 : {myCoin === null ? "확인 불가" : `${amountFormat(myCoin)}C`}</div>
          </ContentDiv>
        )}
        {result && <div role="status" data-admin-modal-message="">
          <p>이 라이브의 {sendType === "알림톡" ? "시작 알림톡" : "정산서"}는 이미 접수되었습니다. 다시 발송할 수 없습니다.</p>
          대상 {result.total}명 · 대기 {result.pending_cnt}명 · 접수 {result.send_cnt}명 · 도착 {result.delivered_cnt}명<br />
          실패 {result.fail_cnt}명 · 확인 필요 {result.unknown_cnt}명 · 사용 코인 {result.charged_coins}C
          <p>접수는 발송 요청이 등록된 상태이며, 실제 수신 여부는 도착 건수로 확인해주세요.</p>
          {result.unknown_cnt > 0 && <p>응답이 불확실한 건은 중복 발송을 막기 위해 자동으로 재발송하지 않습니다. 팬버드 관리자에게 확인을 요청해주세요.</p>}
          {result.failures?.map((failure: any) => <p key={failure.id}>{failure.message}</p>)}
        </div>}
        {sendError && <RedText as={LiveFeedback} role="alert">{sendError}</RedText>}
        {myCoin !== null && myCoin < useCoin && (
          <RedText>보유 코인이 부족합니다. 충전 후 다시 이용해주세요.</RedText>
        )}</div><BtnDiv data-admin-modal-footer="">
          <ApplyBtn
            disabled={readOnly || sending || confirming || isLoading || !!loadError || myCoin === null || (!result && myCoin < useCoin) || Boolean(result)}
            style={{
              cursor: myCoin !== null && myCoin >= useCoin ? "pointer" : "not-allowed",
              opacity: myCoin !== null && myCoin >= useCoin ? 1 : 0.5,
            }}
            onClick={() => {
              if (!readOnly && !sending && !isLoading && !loadError && myCoin !== null) {
                if (sendType !== "알림톡" && !result) setConfirming(true);
                else void submitDispatch();
              }
            }}
          >
            {sending ? '처리 중…' : result ? '발송 접수됨' : '발송하기'}
          </ApplyBtn>
        </BtnDiv>
        
      </ModalBox>
      {!readOnly && confirming && sendType !== "알림톡" && !result && (
        <ConfirmBackdrop data-admin-modal-overlay="" onClick={(event) => { event.stopPropagation(); setConfirming(false); }}>
          <ConfirmPanel data-admin-modal="" ref={confirmationRef} role="alertdialog" aria-modal="true" aria-labelledby={confirmationTitleId} aria-describedby={confirmationBodyId} onClick={stopPropagation}>
            <h2 data-admin-modal-header="" id={confirmationTitleId}>정산서 발송 전 꼭 확인해 주세요</h2>
            <div data-admin-modal-body="" id={confirmationBodyId}>
              <p><strong><span role="img" aria-label="경고">⚠️</span> 발송 이후 발생하는 주문건은 정산서에 포함되거나 재발송되지 않습니다.</strong></p>
              <p>정산서는 1회만 발송할 수 있으므로, 방송이 완전히 마감된 후 진행하세요.</p>
              <p className="automatic-notice">(별도로 보내지 않아도 방송 일정이 종료되면 전체 주문건에 대해 자동 발송됩니다.)</p>
              <p className="coin-notice">수동·자동 발송 모두 대상 5명당 1코인이 차감됩니다. (올림)</p>
            </div>
            <div data-admin-modal-footer="" className="actions">
              <button type="button" onClick={() => setConfirming(false)}>취소</button>
              <button type="button" onClick={() => void submitDispatch()} disabled={sending}>보내기</button>
            </div>
          </ConfirmPanel>
        </ConfirmBackdrop>
      )}
    </Container>
  );
};
export default SendPaymentModal;

const ConfirmBackdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #00000085;
`;

const ConfirmPanel = styled.div`
  position: relative;
  width: min(440px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  box-sizing: border-box;
  padding: 28px 24px 20px;
  border-radius: 8px;
  background: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
  text-align: left;
  h2 { margin: 0 0 20px; font-size: 20px; line-height: 1.4; word-break: keep-all; }
  p { margin: 0 0 16px; font-size: 16px; line-height: 1.6; word-break: keep-all; }
  .automatic-notice, .coin-notice { color: var(--admin-muted); font-size: 14px; }
  .actions { display: flex; gap: 8px; margin-top: 24px; }
  button:focus-visible { outline: 3px solid var(--admin-accent, #7955f0); outline-offset: 3px; }
  button {
    flex: 1;
    height: 48px;
    border: none;
    border-radius: 8px;
    background: var(--admin-theme-raised, #f5f5f5);
    color: var(--admin-muted);
    font: var(--font-weight-semibold) 16px var(--font-family-base);
    cursor: pointer;
  }
  button:last-child { background: linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep)); color: white; }
`;

const Container = styled.div`
  z-index: 99;
  background-color: #00000085;
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
`;

const ModalBox = styled.div`
  box-sizing: border-box;
  width: 95%;
  max-width: 560px;
  margin: auto 0rem;
  background-color: var(--admin-theme-surface, white);
  color: var(--admin-ink);
  border-radius: 8px;
  padding: 24px;
  div.info {
    color: var(--admin-muted);
    font-size: 14px;
    text-align: center;
    line-height: 19px;
  }
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  overscroll-behavior: contain;
`;

const Title = styled.div`
  align-items: center;
  justify-content: flex-start;
  font-size: 20px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  margin-top: 5px;
`;

const ContentDiv = styled.div`
  padding: 0;
  margin-bottom: var(--space-6);
  display: flex;
  align-items: flex-start;
  justify-content: center;
  font-size: 16px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-regular);
  flex-direction: column;
  text-align: center;
  color: var(--admin-muted);
  gap: 10px;
  div.black {
    color: var(--admin-theme-text, black);
    font-family: var(--font-family-base); font-weight: var(--font-weight-medium);
  }
  div.usecoin {
    color: var(--admin-theme-danger, red);
    font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
    font-size: 20px;
  }
  div.mycoin {
    font-size: 14px;
    color: var(--admin-muted);
    align-self: flex-end;
    margin-bottom: 5px;
  }
`;

const BtnDiv = styled(RowView)`
  position: relative;
  width: 100%;
`;

const Btn = styled.button`
  border-radius: 8px;
  height: 48px;
  flex: 1;
  align-items: center;
  justify-content: center;
  display: flex;
  font-size: 16px;
  font-family: var(--font-family-base); font-weight: var(--font-weight-semibold);
  cursor: pointer;
  border: none;
`;

const ApplyBtn = styled(Btn)<{ disabled?: boolean }>`
  background: ${({ disabled }) =>
    disabled
      ? "linear-gradient(135deg, var(--admin-theme-raised, #f5f5f5), var(--admin-theme-raised, #f5f5f5))"
      : "linear-gradient(135deg, var(--admin-accent), var(--admin-accent-deep))"};
  color: ${({ disabled }) => (disabled ? "var(--admin-theme-text, #000000)" : "white")};
`;

const Bar = styled.div`
  width: 100%;
  height: 1px;
  background-color: var(--admin-theme-raised, #e8e8e8);
  margin: 5px 0px;
`;

const RedText = styled.div`
  font-size: 14px;
  color: var(--admin-theme-danger, red);
  text-align: center;
  margin-top: 10px;
`;

const Loading = styled(CenterView)`
  padding: 50px 0px 50px 0px;
  color: var(--admin-theme-muted, #858585);
  div.loading {
    width: 30px;
    height: 30px;
    box-sizing: border-box;
    border: 3px solid var(--admin-accent);
    border-top-color: var(--admin-theme-border, #ffffff);
    border-radius: 100%;
    animation: spin 1s ease-in-out infinite;
  }
  @keyframes spin {
    100% {
      transform: rotate(360deg);
    }
  }
`;
